export const roleConst = {
  owner: 'owner',
  editor: 'editor',
  operator: 'operator',
  reader: 'reader',
} as const
